import {SecureService} from "@/services/superclasses/secure-service";
import {MemberContactList} from "@/interfaces/member-contact-list";
import {MemberContactManage} from "@/interfaces/member-contact-manage";
import {FormResponse} from "@/interfaces/form-response";
import {Status} from "@/interfaces/status";

const api = window.contextPath + '/rest/member-contacts';

export class MemberContactSecureService extends SecureService {

    public prepareNew = async (): Promise<MemberContactManage> => {
        return this.data(await this.get<MemberContactManage>(api + "/prepare-new"))
    };

    public create = async (data: MemberContactManage): Promise<FormResponse<MemberContactManage>> => {
        return this.data(await this.post<FormResponse<MemberContactManage>>(api, data))
    }

    public update = async (id: number, data: MemberContactManage): Promise<FormResponse<MemberContactManage>> => {
        return this.data(await this.put<FormResponse<MemberContactManage>>(api + "/" + id, data))
    }

    public move = async (id: number, newIndex: number, featured: boolean): Promise<Status> => {
        return this.data(await this.put<Status>(api + "/" + id + "/move", null,
            {
                params: {
                    newIndex: newIndex,
                    featured: featured
                }
            }))
    }

    public remove = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/" + id));
    }

    public manage = async (id: number): Promise<MemberContactManage> => {
        return this.data(await this.get<MemberContactManage>(api + "/" + id + "/manage"))
    };

    public loadByMember = async (args: {
        featured?: boolean,
        first?: number,
        max?: number
    }): Promise<MemberContactList[]> => {
        return this.data(await this.get<MemberContactList[]>(api + "/by-member",
            {
                params: args
            }))
    }

    public countByMember = async (args: {
        featured?: boolean
    }): Promise<number> => {
        return this.data(await this.get<number>(api + "/count-by-member",
            {
                params: args
            }))
    }
}

export const memberContactSecureService = new MemberContactSecureService()